import * as Turbo from '@hotwired/turbo';
import 'alpine-turbo-drive-adapter';
import Alpine from 'alpinejs';
import { Alpinejs, appContainer } from '@js/container';
import * as WebComponents from '@js/components';
import '@js/shared/androidAppBanner';
import { initZendeskChatBot } from '@js/worker/zendeskChatBot';
import { initializeEvaluationReview } from '@js/worker/reviewsController';

declare global {
  interface Paid {
    getFRDKey: (callback: (key: string) => void) => void;
  }
  interface Window {
    Alpine: Alpinejs | null;
    startAlpine: () => void;
    google: typeof google;
    mapLoaded: () => void;
    _paid: Paid;
  }
}

function registComponents() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Object.values(WebComponents).forEach((Component: any) => {
    if (Component && Component.tagName && typeof Component === 'function') {
      customElements.define(Component.tagName, Component);
    }
  });
}
registComponents();

Turbo.setProgressBarDelay(200);
Turbo.start();

const alpine: Alpinejs = Alpine as unknown as Alpinejs;
window.Alpine = alpine;

initZendeskChatBot();
appContainer.setApp({ turbo: Turbo, alpine  });
document.addEventListener('turbo:load', () => {
  const path = initializeEvaluationReview();
  if (path) {
    Turbo.visit(path, { action: 'advance' });
  }
});
const isAppUser = document.body.dataset.appUser === 'true';
const REDIRECT_HEADER = 'Workers-Redirect-To';
// Hook Turbo responses for all browser users; the server controls when headers are sent.
if (!isAppUser) {
  document.addEventListener('turbo:before-fetch-response', (event) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const detail = (event as CustomEvent).detail;
    const response = detail?.fetchResponse?.response as Response | undefined;
    if (!response) {
      return;
    }

    const redirectTo = response.headers.get(REDIRECT_HEADER);
    if (!redirectTo) {
      return;
    }

    event.preventDefault();

    Turbo.visit(redirectTo);
  });
}

(async () => {
  const module = await import('@js/worker/alpineController');
  new module.AlpineController();
})();
